<nav aria-label="Table pagination" class="datatable-pagination" *ngIf="totalPages > 1">
  <ul class="pagination-list">
    <!-- First Page Button -->
    <li>
      <button
        type="button"
        class="pagination-button pagination-first"
        [disabled]="currentPage === 1"
        [attr.aria-disabled]="currentPage === 1"
        aria-label="Go to first page"
        (click)="goToPage(1)"
      >
        <i class="datatable-icon-prev" aria-hidden="true"></i>
      </button>
    </li>

    <!-- Previous Page Button -->
    <li>
      <button
        type="button"
        class="pagination-button pagination-prev"
        [disabled]="currentPage === 1"
        [attr.aria-disabled]="currentPage === 1"
        aria-label="Go to previous page"
        (click)="goToPage(currentPage - 1)"
      >
        <i class="datatable-icon-left" aria-hidden="true"></i>
      </button>
    </li>

    <!-- Page Number Buttons -->
    <li *ngFor="let page of visiblePages">
      <button
        *ngIf="isNumber(page)"
        type="button"
        class="pagination-button page-number"
        [class.active]="page === currentPage"
        [attr.aria-current]="page === currentPage ? 'page' : null"
        [attr.aria-label]="'Go to page ' + page"
        (click)="goToPage(page)"
      >
        {{ page }}
      </button>
      <span *ngIf="page === '...'" class="pagination-ellipsis" aria-hidden="true">...</span>
    </li>

    <!-- Next Page Button -->
    <li>
      <button
        type="button"
        class="pagination-button pagination-next"
        [disabled]="currentPage === totalPages"
        [attr.aria-disabled]="currentPage === totalPages"
        aria-label="Go to next page"
        (click)="goToPage(currentPage + 1)"
      >
        <i class="datatable-icon-right" aria-hidden="true"></i>
      </button>
    </li>

    <!-- Last Page Button -->
    <li>
      <button
        type="button"
        class="pagination-button pagination-last"
        [disabled]="currentPage === totalPages"
        [attr.aria-disabled]="currentPage === totalPages"
        aria-label="Go to last page"
        (click)="goToPage(totalPages)"
      >
        <i class="datatable-icon-skip" aria-hidden="true"></i>
      </button>
    </li>
  </ul>
</nav>
